import { Filters } from ".";

export const AdminsFilters: Filters[] = [
  {
    header: "All",
    key: "all",
    value: "all",
  },
  {
    header: "Active",
    key: "is_active",
    value: 1,
  },
  {
    header: "Not Active",
    key: "is_active",
    value: 0,
  },
];
